import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../services';
import { SelectItem } from 'primeng';
import { IUserEmergencyContact } from '../../../interfaces/emergency-contact/user-emergency-contact.dto.interface';
import { MessageService } from 'primeng/api';
import { Message } from '../../../classes/Message';
import { compare } from 'fast-json-patch';
import { IUser } from '../../../interfaces/user';

@Component({
  styleUrls: ['emergency-contact.component.scss'],
  templateUrl: 'emergency-contact.component.html',
})
export class EmergencyContactComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private messageService: MessageService,
  ) {
    this.form = this.fb.group({
      fullName: ['', Validators.required],
      relationshipTypeId: [null, Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^(?:\+44|0)(?:\d{10}|\d{9})$/)]],
      emailAddress: [null],
      addressLine1: [null],
      city: [null],
      postcode: [null],
    });

    this.userId = this.route.snapshot.params['userId'];
    this.backTo = this.route.snapshot.params['backTo'];
  }

  backTo: string;
  userId: any;
  orgType: number;
  form: FormGroup;
  relationshipOptions: SelectItem[] = [];
  originalData: IUserEmergencyContact = null;
  userData: IUser;
  saving: boolean = false;

  async ngOnInit() {
    if (!this.userId) {
      let user = await this.userService.getLoggedUser();
      this.userId = user.id;
    }

    this.userData = await this.userService.getUserData(this.userId);

    this.userService.getCurrentUserOrg().then((res) => {
      this.orgType = res != null ? (this.orgType = res.organisationTypeId) : 0;
    });

    this.userService.getRelationshipTypes().then((res) => {
      this.relationshipOptions = res.map((opt) => {
        return { label: opt.relationshipName, value: opt.id };
      });
    });

    this.getEmergencyContactDetail();
  }

  getEmergencyContactDetail(): void {
    this.userService.getEmergencyContact(this.userId).then((res) => {
      this.originalData = res;
      this.form.patchValue(res);
      this.saving = false;
    });
  }

  get f() {
    return this.form.controls;
  }

  async onSubmit() {
    if (!this.form.valid) {
      return;
    }

    this.form.patchValue({ userId: this.userId });
    let formValue = this.form.value;

    formValue.userId = this.userId;

    try {
      if (!this.originalData) {
        this.saving = true;
        await this.userService.saveEmergencyContact(formValue);
        this.messageService.add(Message.Info('Saved emergency contact'));
        this.getEmergencyContactDetail();
      } else {
        formValue = {
          ...formValue,
          id: this.originalData.id,
          userName: this.originalData.userName,
        };
        const patch = compare(this.originalData, formValue);

        await this.userService.patchEmergencyContact(this.originalData.id, patch);
        this.messageService.add(Message.Info('Updated emergency contact'));
      }
      this.onClose();
    } catch {
      this.messageService.add(Message.Error('Could not save emergency contact'));
      this.saving = false;
    }
  }

  onClose() {
    if (this.backTo) this.router.navigate([this.backTo]);
    else this.router.navigate(['app/home']);
  }
}
